import React from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';

/**
 *
 * @param {*} props - props for the start order item
 *
 */
const StartOrderItems = props => {
  const { contentData = {}, clickHandler = null } = props;
  const { buttonText = '', startOrderTitle = '', ariaLabel = '' } = contentData;
  return (
    <div
      className={window.location.href.includes('menu') ? 'headerBottom plpHeaderBottom' : 'headerBottom'}
      data-testid='start-order-items'
    >
      <div className='headBottomParent'>
        <div className='headBottomTxt'>{startOrderTitle}</div>
        <ContainedButton
          data-testid='start-order-button'
          variant={ButtonType.primary}
          aria-label={ariaLabel || buttonText}
          onClickHandler={clickHandler}
          id='startOrderItemButton'
          type='submit'
        >
          <span>{buttonText}</span>
        </ContainedButton>
      </div>
    </div>
  );
};
export default StartOrderItems;
